<template>
<div class="content_card_content">
<DataTable 
:value="data" 
:paginator="true" 
:lazy="true"
class="p-datatable-suppliers" 
:rows="10"
dataKey="id" 
:rowHover="true"
filterDisplay="menu" 
:loading="loading"
paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
responsiveLayout="scroll"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
:totalRecords="totalRecords"
@page="onPage($event)"
@sort="onSort($event)" 
@filter="onFilter($event)"
@update:filters="updateFilters"
editMode="cell" 
@cell-edit-complete="onCellEditComplete"
@cell-edit-init="onCellEditInit"
:page="page+1"
:first="first"
v-model:filters="filters"
:editingRows="editingRows"
>

<template #header>
<div class="grid">
<div class="col flex justify-content-start  align-items-center">
<p v-if="totalRecords" class="text-primary mx-0  my-0">{{$store.state.languages.lang_phrases.toplam_kayit}} <span class="font-bold">{{totalRecords}}</span></p>
</div>



<div class="flex justify-content-end  align-items-center ml-2 col" style="flex-grow:2"> 

<div class="hide_on_mobile ">
<!--
<Button label="Bu Filtreyi Kaydet" class=" p-button-success p-button-outlined  p-button-sm mr-2"  icon="pi pi-plus" @click="openTemplatesModal" ></Button>
-->


<template v-if="selected_brands.length===1 || brands.length===1">
<!--
<Button label="Filtreleri Yönet" class=" p-button-help p-button-outlined  p-button-sm mr-2"  icon="pi pi-list" @click="openTemplatesModal" ></Button>
-->

<template v-if="customattributefilters.length">
  <Button label="Özel Nitelikle Filtrele" class=" p-button-danger p-button-outlined  p-button-sm mr-2"  icon="pi pi-filter" @click="openCustomAttributeFilterDialog" :badge="customattributefilters.length.toString()" badgeClass="p-badge-danger"></Button>
</template>
<template v-else>
  <Button label="Özel Nitelikle Filtrele" class=" p-button-danger p-button-outlined  p-button-sm mr-2"  icon="pi pi-filter" @click="openCustomAttributeFilterDialog" ></Button>
</template>
</template>




<template v-if="is_planner || is_admin">
  <template v-if="selected_brands.length===1 || brands.length===1">
    <Button label="Sütunları Yönet" class=" p-button-info p-button-outlined  p-button-sm mr-2"  icon="pi pi-sort-alt" @click="openPlannerSpecificColumn" ></Button>
  </template>
  
</template>
 <Button :label="$store.state.languages.lang_phrases.excel_rapor_indir" class=" p-button-primary p-button-outlined  p-button-sm mr-2"  icon="pi pi-cloud-download" @click="downloadExcel" :loading="preparing_excel"></Button>
<!--
 <Button :label="$store.state.languages.lang_phrases.filtre_sablonlarini_yonet" class=" p-button-success p-button-outlined  p-button-sm mr-2"  icon="pi pi-bookmark" @click="manageFilterTemplates" ></Button>
-->
</div>



<span class="p-input-icon-left  ">
<i class="pi pi-search" />
<InputText v-model="searchterm" :placeholder="$store.state.languages.lang_phrases.arama" class=" p-inputtext-sm" @input="searchSupplier" :showClear="true"/>
</span>



<div class="show_on_mobile">


<Button type="button"  icon="pi pi-ellipsis-h" @click="toggleMenu($event)" aria-haspopup="true" aria-controls="overlay_menu" class="p-button-primary p-button-text p-button-sm mt-0 mr-1"   />
<Menu id="overlay_menu" ref="user_menu" :model="usermenuitems" :popup="true">
<template #item="{item}">  

<template v-if="item.id=='columns'">
<template v-if="is_planner || is_admin">
  <template v-if="selected_brands.length===1">
    <a class="p-menuitem-link" role="menuitem" @click="item.command()">
    <span :class="'p-menuitem-icon '+item.icon"></span>
    <span class="p-menuitem-text">{{item.label}}</span>
    <span class="p-ink"></span></a>
  </template>
  <template v-else-if="brands.length===1">
    <a class="p-menuitem-link" role="menuitem" @click="item.command()">
    <span :class="'p-menuitem-icon '+item.icon"></span>
    <span class="p-menuitem-text">{{item.label}}</span>
    <span class="p-ink"></span></a>
  </template>  
</template>  
</template>

<template v-if="item.id=='excel' || item.id=='template'">
<a class="p-menuitem-link" role="menuitem" @click="item.command()">
<span :class="'p-menuitem-icon '+item.icon"></span>
<span class="p-menuitem-text">{{item.label}}</span>
<span class="p-ink"></span></a>

</template>


</template>
</Menu>

</div>



</div>










</div>



</template>

<template #empty>
<div class="grid">
<div class="flex justify-content-center  align-items-center mx-6 col"> 
<h3 class="text-primary"> {{$store.state.languages.lang_phrases.sonuc_bulunamadi}}</h3>
</div>
</div>   
</template>
<template #loading>
<div class="loading_overlay">
<ProgressSpinner style="width:50px;height:50px" strokeWidth="4" />
{{$store.state.languages.lang_phrases.yukleniyor_lutfen_bekleyin}}
</div>
</template>

<Column   :header="$store.state.languages.lang_phrases.isim"  sortable field="supplier_name" style="min-width: 8rem">
<template #body="slotProps">
<router-link class="text-primary p-link no-underline" :to="{ name: routename , params: { id: slotProps.data.id }}">{{ slotProps.data.supplier_name}}</router-link>
</template>
</Column>

<Column   :header="$store.state.languages.lang_phrases.tedarikci_kodu"  sortable field="suppliercode">
<template #body="slotProps">
<p>{{ slotProps.data.suppliercode}}</p>
</template>
</Column>

<Column   
:header="$store.state.languages.lang_phrases.marka" 
sortable 
field="brand_name"
filterField="brand_name" 
:showFilterMatchModes="false" 
:filterMenuStyle="{ width: '14rem' }">
<template #body="slotProps">
<p>{{ slotProps.data.brand_name}}</p>
</template>

<template #filter="{ filterModel }">
    <MultiSelect filter v-model="filterModel.value"   :options="brands" optionLabel="name" optionValue="id" placeholder="Any" class="p-column-filter">        
    </MultiSelect>
</template>
</Column>

<Column   
:header="$store.state.languages.lang_phrases.proje"  
sortable 
field="project_name"
filterField="project_name" 
:showFilterMatchModes="false" 
:filterMenuStyle="{ width: '14rem' }">
<template #body="slotProps">
<router-link class="text-primary p-link no-underline" :to="{ name: 'SupplierProjectAllPeriods' , params: { id: slotProps.data.supplier_id,project_id:slotProps.data.project_id }}">{{ getTheTranslationByArray(slotProps.data.project_translations,"translation")}}</router-link>
</template>
<template #filter="{ filterModel }">
    <MultiSelect filter v-model="filterModel.value"  :options="projects" optionLabel="name" optionValue="id" placeholder="Any" class="p-column-filter">        
    </MultiSelect>
</template>
</Column>

<Column   
:header="$store.state.languages.lang_phrases.donem"  
sortable 
field="projectperiod_name"
filterField="projectperiod_name" 
:showFilterMatchModes="false" 
:filterMenuStyle="{ width: '14rem' }">
<template #body="slotProps">
<template v-if="slotProps.data.projectsupplier_uuid">
<router-link class="text-primary p-link no-underline" :to="{ name: 'SupplierProject' , params: { id: slotProps.data.supplier_id,project_id:slotProps.data.projectsupplier_uuid }}">{{ slotProps.data.projectperiod_name}}</router-link>
</template>
<template v-else>
<p>{{ slotProps.data.projectperiod_name}}</p>
</template>


</template>
<template #filter="{ filterModel }">
    <MultiSelect filter v-model="filterModel.value"  :options="periods" optionLabel="name" optionValue="id" placeholder="Any" class="p-column-filter">
      <template #option="slotProps">
        {{slotProps.option.name}} - {{slotProps.option.project.name}}
    </template>
    </MultiSelect>
</template>
</Column>

<Column   
:header="$store.state.languages.lang_phrases.akis"  
sortable 
field="flow_name"
filterField="flow_name" 
:showFilterMatchModes="false" 
:filterMenuStyle="{ width: '14rem' }">
<template #body="slotProps">
  <template v-if="slotProps.data.projectsupplier_uuid">
    <router-link class="text-primary p-link no-underline" :to="{ name: 'SupplierProjectFlowSummary' , params: { id: slotProps.data.supplier_id,project_id:slotProps.data.projectsupplier_uuid,flow_id:slotProps.data.flowsupplier_uuid }}">{{ getTheTranslationByArray(slotProps.data.flow_translations,"translation")}}</router-link>
  </template>
  <template v-else>
    <p>{{ getTheTranslationByArray(slotProps.data.flow_translations,"translation")}}</p>
  </template>
</template>
<template #filter="{ filterModel }">
    <MultiSelect filter  v-model="filterModel.value"  :options="flows" optionLabel="name" optionValue="id" placeholder="Any" class="p-column-filter">        
    </MultiSelect>
</template>
</Column>



<Column   
:header="$store.state.languages.lang_phrases.aktif_akis"  
sortable 
field="flow_type"
filterField="flow_type" 
:showFilterMatchModes="false" 
:filterMenuStyle="{ width: '14rem' }">
<template #body="slotProps">

<template v-if="slotProps.data.flow_type=='self_evaluation'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.self_evaluation" 
style="background-color:#ff6600"
/>  
</template>

<template v-if="slotProps.data.flow_type=='verification'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.verification" 
style="background-color:#7e2f8d"
/>  
</template>

<template v-if="slotProps.data.flow_type=='audit'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.audit" 
style="background-color:#352f8d"
/>  
</template>

</template>
<template #filter="{ filterModel }" v-if="pagetype=='verification'">    
    <MultiSelect v-model="filterModel.value" :options="flowtypes"  placeholder="Any" class="p-column-filter">
    <template #option="slotProps">
      <div class="flex align-items-center gap-2">

          <template v-if="slotProps.option=='self_evaluation'">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases.self_evaluation" 
          style="background-color:#ff6600"
          />  
          </template>

          <template v-if="slotProps.option=='verification'">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases.verification" 
          style="background-color:#7e2f8d"
          />  
          </template>
          

          <template v-if="slotProps.option=='audit'">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases.audit" 
          style="background-color:#352f8d"
          />  
          </template>


      </div>
  </template>
</MultiSelect>


</template>
</Column>






<Column   :header="$store.state.languages.lang_phrases.durum"  
sortable 
field="status"
filterField="status" 
:showFilterMatchModes="false" 
:filterMenuStyle="{ width: '14rem' }">
<template #body="slotProps">

<template v-if="slotProps.data.status=='awaiting_schedule'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.planlama_bekliyor" 
style="background-color:#352f8d"
/>  
</template>

<template v-if="slotProps.data.status=='scheduled'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.planlandi" 
style="background-color:#4dc247"
/>  
</template>

<template v-if="slotProps.data.status=='finished'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.tamamlandi0" 
style="background-color:#4dc247"
/>  
</template>

<template v-if="slotProps.data.status=='exempt'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.muaf" 
style="background-color:#10b981"
/>  
</template>

<template v-if="slotProps.data.status=='rescheduled'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.tekrar_planlandi" 
style="background-color:#ff6600"
/>  
</template>

<template v-if="slotProps.data.status=='on_planning'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.planlamada" 
style="background-color:#3b82f6"
/>  
</template>

<template v-if="slotProps.data.status=='under_review'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.degerlendirmede" 
style="background-color:#ff6600"
/>  
</template>

<template v-if="slotProps.data.status=='started'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.baslandi" 
style="background-color:#dd4b39"
/>  
</template>

<template v-if="slotProps.data.status=='added_to_verification'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.dogrulamaya_aktarildi" 
style="background-color:red"
/>  
</template>

<template v-if="slotProps.data.status=='deleted'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.iptal_edildi" 
style="background-color:#661814"
/>  
</template>

</template>


<template #filter="{ filterModel }">
<MultiSelect v-model="filterModel.value" :options="statuses"  placeholder="Any" class="p-column-filter">
  <template #option="slotProps">
      <div class="flex align-items-center gap-2">
          <template v-if="slotProps.option=='awaiting_schedule'">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases.planlama_bekliyor" 
          style="background-color:#352f8d"
          />  
          </template>

          <template v-if="slotProps.option=='scheduled'">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases.planlandi" 
          style="background-color:#4dc247"
          />  
          </template>
          

          <template v-if="slotProps.option=='rescheduled'">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases.tekrar_planlandi" 
          style="background-color:#ff6600"
          />  
          </template>

          <template v-if="slotProps.option=='finished'">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases.tamamlandi0" 
          style="background-color:#4dc247"
          />  
          </template>

          <template v-if="slotProps.option=='exempt'">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases.muaf" 
          style="background-color:#10b981"
          />  
          </template>

          <template v-if="slotProps.option=='under_review'">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases.degerlendirmede" 
          style="background-color:#3b82f6"
          />  
          </template>

          <template v-if="slotProps.option=='started'">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases.baslandi" 
          style="background-color:#dd4b39"
          />  
          </template>

          <template v-if="slotProps.option=='added_to_verification'">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases.dogrulamaya_aktarildi" 
          style="background-color:red"
          />  
          </template>

          <template v-if="slotProps.option=='deleted'">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases.iptal_edildi" 
          style="background-color:#661814"
          />  
          </template>


      </div>
  </template>
</MultiSelect>
</template>

</Column>

<Column  
sortable 
field="created_at" 
:header="$store.state.languages.lang_phrases.eklenme_tarihi"
:showFilterMatchModes="false" 
filterMenuClass="calendar_class"
filterHeaderClass="filter_header_class"
:unstyled="true"
style="min-width: 8rem">
    <template #body="{data}">
        {{ $filters.momentFormat( data.created_at," Do MM YYYY HH:mm")}}
    </template>
    <template #filter="{ filterModel }">
      <div>
      <VueDatePicker 
        v-model="filterModel.value" 
        range        
        :time-picker="false"
        :enable-time-picker="false"
        :month-change-on-scroll="false"
        :auto-apply="true"
        :locale="preflangcode"
        auto-position="top"
      >
      </VueDatePicker>
      <span class="p-float-label mb-0 mt-4">
        <Dropdown v-model="filterModel.time_period" :options="time_periods" id="created_at_period_selector" optionLabel="name" optionValue="id"  class="w-full  p-inputtext-sm" @change="timeOptionSelected($event,'created_at')">
        </Dropdown>
        <label for="created_at_period_selector">Zaman Aralığı</label>
      </span>

    </div>
  </template>
  <template #filterclear="{ filterCallback }">
      <Button type="button" label="Clear" @click="filterCallback()" severity="secondary" class="p-button-outlined p-button-sm"></Button>
  </template>
  <template #filterapply="{ filterCallback }">
      <Button type="button" label="Apply" @click="filterCallback()" severity="success" class="p-button-sm"></Button>
  </template>
</Column>

<Column 
:header="$store.state.languages.lang_phrases.oturum_tarihi"  
sortable 
class="tetetest"
field="scheduled_at" 
:showFilterMatchModes="false" 
filterMenuClass="calendar_class"
style="min-width: 8rem">
    <template #body="{data}">
        {{ $filters.momentFormat( data.scheduled_at," Do MM YYYY HH:mm")}}
    </template>
    <template #filter="{ filterModel }">
      <div>
        <VueDatePicker 
        v-model="filterModel.value" 
        range        
        :time-picker="false"
        :enable-time-picker="false"
        :month-change-on-scroll="false"
        :auto-apply="true"
        auto-position="top"
        :locale="preflangcode"
        panelClass="filtercalendar"
      >
      </VueDatePicker>
      <span class="p-float-label mb-0 mt-4">
        <Dropdown v-model="filterModel.time_period" :options="time_periods" id="scheduled_at_period_selector" optionLabel="name" optionValue="id"  class="w-full  p-inputtext-sm" @change="timeOptionSelected($event,'scheduled_at')">
        </Dropdown>
        <label for="scheduled_at_period_selector">Zaman Aralığı</label>
      </span>
    </div>
  </template>
  <template #filterclear="{ filterCallback }">
      <Button type="button" label="Clear" @click="filterCallback()" severity="secondary" class="p-button-outlined p-button-sm"></Button>
  </template>
  <template #filterapply="{ filterCallback }">
      <Button type="button" label="Apply" @click="filterCallback()" severity="success" class="p-button-sm"></Button>
  </template>
</Column>


<Column   
:header="$store.state.languages.lang_phrases.denetci" 
sortable 
field="auditor_name"
filterField="auditor_name" 
:showFilterMatchModes="false" 
:filterMenuStyle="{ width: '14rem' }">
<template #body="slotProps">
<p>{{ slotProps.data.auditor_name}}</p>
</template>
<template #filter="{ filterModel }">
    <MultiSelect filter v-model="filterModel.value"  :options="auditors" optionLabel="name" optionValue="id" placeholder="Any" class="p-column-filter">        
    </MultiSelect>
</template>
</Column>



<!-- custom columns -->
<template v-for="column in brand_columns">

<!-- text -->
<template v-if="column.columntype=='text'">
  <Column
  
  :header="column.name" 
  :field="'column_'+column.id.toString()"
  style="min-width: 10rem"
  :filterField="'column_'+column.id.toString()" 
  :showFilterMatchModes="false" 
  :filterMenuStyle="{ width: '14rem' }"
  >
  <template #body="slotProps">
    <PlannerTableTextCellBody :data="slotProps.data[slotProps.field.replace('column_','')+'_note']"/>    
  </template>
  <template #editor="{ data, field }">
    <Textarea  
    v-model="data[field.replace('column_','')+'_note']" 
    autofocus 
    rows="5" 
    cols="30" 
    autoResize  
    @keydown.enter.stop="adjustTextLineBreak(data,field)"
    />
  </template>
  <template #filter="{ filterModel }">
      <InputText v-model="filterModel.value" 
      type="text"  
      class="p-column-filter w-full" 
      placeholder="Arama" />
  </template>
  <template #filterclear="{ filterCallback }">
      <Button type="button" label="Clear" @click="filterCallback()" severity="secondary" class="p-button-outlined p-button-sm"></Button>
  </template>
  <template #filterapply="{ filterCallback }">
      <Button type="button" label="Apply" @click="filterCallback()" severity="success" class="p-button-sm"></Button>
  </template>

  </Column>
</template>
<!-- text -->


<!-- date -->
<template v-if="column.columntype=='date'">
  <Column
  :field="'column_'+column.id.toString()"
  style="min-width: 10rem"
  :filterField="'column_'+column.id.toString()" 
  :showFilterMatchModes="false" 
  :filterMenuStyle="{ width: '28rem' }"
  >
  <template #header>
  <span class="p-column-title" @click="checkColumn(column)">{{column.name}}</span>
</template>
  <template #body="slotProps">
    {{ $filters.momentFormat( slotProps.data[slotProps.field.replace('column_','')+'_date']," DD-MM-YYYY")}}
  </template>
  <template #editor="{ data, field }">
    <Calendar v-model="data[field.replace('column_','')+'_date']" showButtonBar  touchUI />
  </template>
  <!--
  <template #filter="{ filterModel }">
      <div>
        <br/><br/>
      <Calendar v-model="filterModel.value" 
      selectionMode="range" 
      :manualInput="false" 
      showButtonBar
      panelClass="filtercalendar"
      :hideOnRangeSelection="true"
      @update:modelValue="dateselecttest"/>
    </div>
  </template>
  -->



  <template #filter="{ filterModel }">
      <div>
        <VueDatePicker 
        v-model="filterModel.value" 
        range        
        :time-picker="false"
        :enable-time-picker="false"
        :month-change-on-scroll="false"
        :auto-apply="true"
        auto-position="top"
        :locale="preflangcode"
        panelClass="filtercalendar"
      >
      </VueDatePicker>
      <span class="p-float-label mb-0 mt-4">
        <Dropdown v-model="filterModel.time_period" :options="time_periods" :id="'column_'+column.id" optionLabel="name" optionValue="id"  class="w-full  p-inputtext-sm" @change="timeOptionSelected($event,'column_'+column.id)">
        </Dropdown>
        <label :for="'column_'+column.id">Zaman Aralığı</label>
      </span>
    </div>
  </template>





  <template #filterclear="{ filterCallback }">
      <Button type="button" label="Clear" @click="filterCallback()" severity="secondary" class="p-button-outlined p-button-sm"></Button>
  </template>
  <template #filterapply="{ filterCallback }">
      <Button type="button" label="Apply" @click="filterCallback()" severity="success" class="p-button-sm"></Button>
  </template>



  </Column>
</template>
<!-- date -->


<!-- select -->
<template v-if="column.columntype=='select'">
  <Column
  :header="column.name" 
  :field="'column_'+column.id.toString()"
  style="min-width: 10rem"
  :filterField="'column_'+column.id.toString()" 
  :showFilterMatchModes="false" 
  :filterMenuStyle="{ width: '14rem' }"
  >
  <template #body="slotProps">
    <template v-if="getColumnSelectVal(column.id,slotProps.data)">
      <Tag 
      class="ml-2  mb-2 custom-chip" 
      :value="getColumnSelectVal(column.id,slotProps.data)" 
      style="background-color:#3b82f6"
      /> 
    </template>
     

  </template>
  <template #editor="{ data, field }">
    <Dropdown v-model="data[field.replace('column_','')+'_option']" :options="column.options" optionLabel="name" optionValue="id"  class="w-full  p-inputtext-sm">
      <template #option="slotProps">
        <div v-if="slotProps.option.id">
            {{ slotProps.option.name }}
        </div>
    </template>

    </Dropdown>
  </template>

  <template #filter="{ filterModel }">
      <MultiSelect v-model="filterModel.value" :options="column.options" optionLabel="name" optionValue="id" placeholder="Any" class="p-column-filter ">        
      </MultiSelect>
  </template>

  
  </Column>
</template>
<!-- select -->




</template>
<!-- custom columns -->




<!-- customattribute columns -->

<template v-if="customattributefilters.length">
<template v-for="column in customattributefilters">

<!-- text -->
<template v-if="column.type=='text'">
  <Column
  
  :header="column.name" 
  :field="'column_'+column.id.toString()"
  style="min-width: 10rem"
  >
  <template #body="slotProps">
    <PlannerTableTextCellBody :data="slotProps.data[slotProps.field.replace('column_','')+'_note']"/>    
  </template>
  </Column>
</template>
<!-- text -->





<!-- select -->
<template v-if="column.type=='select'">
  <Column
  :header="column.name" 
  :field="'column_'+column.id.toString()"
  style="min-width: 10rem"
  >
  <template #body="slotProps">
    <PlannerTableSelectAttribute 
    :column_id="column.id"
    :column_data="slotProps.data"
    :customattributefilters="customattributefilters" />
  </template>
  
  
  </Column>
</template>
<!-- select -->

<!-- select -->
<template v-if="column.type=='boolean'">
  <Column
  :header="column.name" 
  :field="'column_'+column.id.toString()"
  style="min-width: 10rem"
  >
  <template #body="slotProps">
    <PlannerTableBooleanAttribute 
    :column_id="column.id"
    :column_data="slotProps.data"
    :customattributefilters="customattributefilters" />
  </template>
  
  
  </Column>
</template>
<!-- select -->

<!-- multiselect -->
<template v-if="column.type=='multiselect'">
  <Column
  :header="column.name" 
  :field="'column_'+column.id.toString()"
  style="min-width: 10rem"
  >
  <template #body="slotProps">
    <PlannerTableMultiSelectAttribute 
    :column_id="column.id"
    :column_data="slotProps.data"
    :customattributefilters="customattributefilters" />
  </template>

  
  </Column>
</template>
<!-- multiselect -->



</template>
</template>

<!-- customattribute columns -->




<Column headerStyle="width: 4rem; text-align: center" bodyStyle="text-align: center; overflow: visible">
<template #body="{data}">
<Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event,data.id)" aria-haspopup="true" :aria-controls="'overlay_menu'+data.id" class="p-button-primary p-button-text p-button-sm mt-1"   />
<Menu :id="'overlay_menu'+data.id" :ref="'menu'+data.id" :model="menuitems" :popup="true">
<template #item="{item}">  
<a class="p-menuitem-link" role="menuitem" @click="item.command({id:data.id})">
<span :class="'p-menuitem-icon '+item.icon"></span>
<span class="p-menuitem-text">{{item.label}}</span>
<span class="p-ink"></span></a>
</template>
</Menu>

</template>
</Column>






</DataTable>


<PlannerTableTemplateSidebar 
:schema="filters"
:customattributefilters="customattributefilters"
:brand_columns="brand_columns"
:pagetype="pagetype"
@applyFilter="applyFilter"
/>

<PlannerSpecificColumnDialog ref="planner_dialog" :brand_id="singleBrandId" @renewData="getData" :type="pagetype">
</PlannerSpecificColumnDialog>

<PlannerTableCustomAttributeFilter ref="customattributedialog" :brand_id="singleBrandId" :filters="customattributefilters" @filterSelected="customAttributeFilterSelected"/>

</div>
</template>

<script>
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import * as XLSX from 'xlsx/xlsx.mjs';
import moment from "moment"
import PlannerTableCustomAttributeFilter from "./PlannerTableCustomAttributeFilter"
import PlannerTableTextCellBody from "./PlannerTableTextCellBody"
import PlannerTableSelectAttribute from "./PlannerTableSelectAttribute"
import PlannerTableBooleanAttribute from "./PlannerTableBooleanAttribute"
import PlannerTableMultiSelectAttribute from "./PlannerTableMultiSelectAttribute"
import PlannerTableTemplateSidebar from "./PlannerTableTemplateSidebar"


export default {

  name: 'PlannerTable',
  props:["pagetype","routename"],
  components:{PlannerTableCustomAttributeFilter,PlannerTableTextCellBody,PlannerTableSelectAttribute,PlannerTableMultiSelectAttribute,PlannerTableTemplateSidebar,PlannerTableBooleanAttribute},
  data () {
    return {
      data:[],
      editingRows:[],
      searchterm:"",
      intervalobj:null,
      loading:true,
      totalRecords:0,
      preparing_excel:false,
      brands:[],
      projects:[],
      projectperiods:[],
      flows:[],
      periods:[],
      auditors:[],
      selected_brands:[],
      selected_projects:[],
      selectedprojectperiods:[],
      selected_flows:[],
      selected_periods:[],
      selected_auditors:[],
      selected_statuses:[],
      selected_types:[],
      download_data:[],
      customattributefilters:[],
      workbook:null,
      brand_columns:[],
      managed_filters:[],
      customattribute_columns:[],
      time_periods:[
        {id:"thisweek",name:"Bu Hafta"},
        {id:"thismonth",name:"Bu Ay"},
        {id:"thisquarter",name:"Bu Çeyrek"},
        {id:"thisyear",name:"Bu Yıl"},
        {id:"lastweek",name:"Son 1 Hafta"},
        {id:"lastfifteendays",name:"Son 15 Gün"},
        {id:"lastthirtydays",name:"Son 30 Gün"},
        {id:"lastninetydays",name:"Son 90 Gün"},
        {id:"lastoneeightydays",name:"Son 180 Gün"},
      ],
      first:0,
      page:0,
      sort_column:"created_at",
      sort_order:"desc",      
      
      menuitems: [
          {
              label: 'Görüntüle',
              icon: 'pi pi-eye',
              command: (id) => {
                  this.gotoPage(this.routename,id)
                  }
          }          
      ],
      filters:{
        brand_name: { value: [], matchMode: FilterMatchMode.IN },
        project_name: { value: [], matchMode: FilterMatchMode.IN },
        projectperiod_name: { value: [], matchMode: FilterMatchMode.IN },
        flow_name: { value: [], matchMode: FilterMatchMode.IN },     
        auditor_name: { value: [], matchMode: FilterMatchMode.IN },        
        status: { value: [], matchMode: FilterMatchMode.IN },       
        flow_type: { value: [], matchMode: FilterMatchMode.IN },   
        created_at: { value: [],time_period:null, matchMode: FilterMatchMode.IN },   
        scheduled_at: { value: [],time_period:null, matchMode: FilterMatchMode.IN },
      },
      
    }
  },
  computed:{
    preflangcode()
    {
      if(this.$store.state.auth.user && this.$store.state.auth.user.preflang)
      {
        return this.$store.state.auth.user.preflang.code
      }
      return "tr"
    },
    usermenuitems()
    {
      return [
          {
              label: 'Özel Nitelikle Filtrele',
              icon: 'pi pi-tags',
              id:"template",
              command: () => {
                    this.openCustomAttributeFilterDialog()
                  }
          }, 
          {
              label: 'Sütunları Yönet',
              icon: 'pi pi-sort-alt',
              id:"columns",
              command: () => {
                    this.openPlannerSpecificColumn()
                  }
          },
          {
              label: 'Excel Rapor İndir',
              icon: 'pi pi-file-excel',
              id:"excel",
              command: () => {
                    this.downloadExcel()
                  }
          },
          {
              label: this.$store.state.languages.lang_phrases.filtre_sablonlarini_yonet,
              icon: 'pi pi-file-excel',
              id:"excel",
              command: () => {
                    this.manageFilterTemplates()
                  }
          },

      ]
    },
  	statuses()
  	{
  		if(this.pagetype=="verification")
  		{
  			return ['awaiting_schedule', 'scheduled', 'rescheduled',"started","under_review","finished","deleted"]
  		}

  		if(this.pagetype=="preaudit")
  		{
  			return ['awaiting_schedule', 'scheduled', 'rescheduled',"added_to_verification","deleted"]
  		}

  		if(this.pagetype=="audit")
  		{
  			return ['awaiting_schedule', 'scheduled', 'rescheduled',"started","under_review","finished","exempt","deleted"]
  		}
  		
  	},
    flowtypes()
    {
      if(this.pagetype=="verification")
      {
        return ['verification', 'self_evaluation']
      }
      if(this.pagetype=="audit")
      {
        return ['audit']
      }
    },
    singleBrandId()
    {
      if(this.selected_brands.length===1)
      {
        return this.selected_brands[0]
      }
      if(this.brands.length===1)
      {
        return this.brands[0].id
      }
      return null
    },
    is_planner()
    {
      let roles = this.$store.state.auth.user.userroles
      roles = roles.map(item=>item.name)
      if(roles.includes("planner"))
      {
        return true
      }
      return false
    },
    is_brand()
    {
      let roles = this.$store.state.auth.user.userroles
      roles = roles.map(item=>item.name)
      if(roles.includes("brand"))
      {
        return true
      }
      return false
    },
    is_admin()
    {
      let roles = this.$store.state.auth.user.userroles
      roles = roles.map(item=>item.name)
      if(roles.includes("admin") )
      {
        return true
      }
      return false
    },
  },
  mounted()
  {    
  	this.getBrands();
  },
  methods:{

    timeOptionSelected(event,type)
    {      
      let start = moment()
      let end = moment()
      if(event.value=="thisweek")
      {
        start = moment().startOf('week')
        end = moment().endOf('week')
      }
      if(event.value=="thismonth")
      {
        start = moment().startOf('month')
        end = moment().endOf('month')
      }
      if(event.value=="thisquarter")
      {
        start = moment().quarter(moment().quarter()).startOf('quarter');
        end = moment().quarter(moment().quarter()).endOf('quarter');
      }
      if(event.value=="thisyear")
      {
        start = moment().startOf('year')
        end = moment().endOf('year')
      }
      if(event.value=="lastweek")
      {
        start = moment().subtract(1, 'weeks')
        end = moment()
      }
      if(event.value=="lastfifteendays")
      {
        start = moment().subtract(15, 'days')
        end = moment()
      }
      if(event.value=="lastthirtydays")
      {
        start = moment().subtract(30, 'days')
        end = moment()
      }
      if(event.value=="lastninetydays")
      {
        start = moment().subtract(90, 'days')
        end = moment()
      }
      if(event.value=="lastoneeightydays")
      {
        start = moment().subtract(180, 'days')
        end = moment()
      }

      this.filters[type].time_period = event.value
      this.filters[type].value = []
      this.filters[type].value.push(start)
      this.filters[type].value.push(end)  
    },
    checkTimePeriodState(column_type)
    {
        let time_period = this.filters[column_type].time_period
        let val_arr = this.filters[column_type].value
        let start = moment()
        let end = moment()
        //if time_period
        if(time_period)
        {
          if(time_period=="thisweek")
          {
            start = moment().startOf('week')
            end = moment().endOf('week')
          }
          if(time_period=="thismonth")
          {
            start = moment().startOf('month')
            end = moment().endOf('month')
          }
          if(time_period=="thisquarter")
          {
            start = moment().quarter(moment().quarter()).startOf('quarter');
            end = moment().quarter(moment().quarter()).endOf('quarter');
          }
          if(time_period=="thisyear")
          {
            start = moment().startOf('year')
            end = moment().endOf('year')
          }
          if(time_period=="lastweek")
          {
            start = moment().subtract(1, 'weeks')
            end = moment()
          }
          if(time_period=="lastfifteendays")
          {
            start = moment().subtract(15, 'days')
            end = moment()
          }
          if(time_period=="lastthirtydays")
          {
            start = moment().subtract(30, 'days')
            end = moment()
          }
          if(time_period=="lastninetydays")
          {
            start = moment().subtract(90, 'days')
            end = moment()
          }
          if(time_period=="lastoneeightydays")
          {
            start = moment().subtract(180, 'days')
            end = moment()
          }
          start = start.format('L') 
          end = end.format('L')
          if(val_arr && val_arr.length)
          {
            let val_1 = moment(val_arr[0]).format('L')
            let val_2 = moment(val_arr[1]).format('L')
            if(start !==val_1 || end !==val_2)
            {
              this.filters[column_type].time_period = null
            }
          }
          else
          {
            this.filters[column_type].time_period = null
          }
          
        }
        //if time_period
      
    },
    adjustTextLineBreak(data,field)
    {
      let data_field_name = field.replace("column_","")+"_note"
      let ind = this.data.findIndex(item=>item.id == data.id)
      this.data[ind][data_field_name] += "\n"
    },
    checkColumn(column)
    {
      console.log(column)
      console.log(this.filters)
    },
    openCustomAttributeFilterDialog()
    {
      this.$refs.customattributedialog.showDialog()
    },
    customAttributeFilterSelected(data)
    {
      this.customattributefilters = data
      this.page = 0
      this.getData()
    },
    dateselecttest(data)
    {
      
    },
    updateFilters(data)
    {
    },
    getAttributeColumnSelectColor(column_id,column_data)
    {
      let the_column = this.customattributefilters.find(item=>item.id == column_id)
      let data = column_data[column_id+"_select"]
      if(data)
      {
        let option = the_column.fulloptions.find(item=>item.id == data)
        if(option)
        {
          return "#"+option.color
        }
        return "#3b82f6"
      }
      return "#3b82f6"
    },
    getAttributeColumnSelectVal(column_id,column_data)
    {
      let the_column = this.customattributefilters.find(item=>item.id == column_id)
      let data = column_data[column_id+"_select"]
      if(data)
      {
        let option = the_column.fulloptions.find(item=>item.id == data)
        if(option)
        {
          if(option.color)
          {

          }
          return option.name
        }
        return null
      }
      return null
    },
    getAttributeColumnMultiSelectVal(column_id,column_data)
    {
      let the_column = this.customattributefilters.find(item=>item.id == column_id)
      let data = column_data[column_id+"_multiselect"]
      if(data)
      {

        data = JSON.parse(data)
        let option = the_column.options.find(item=>item.id == data)
        if(option)
        {
          return option.name
        }
        return null
      }
      return null
    },
    getColumnSelectVal(column_id,column_data)
    {
      let the_column = this.brand_columns.find(item=>item.id == column_id)
      let data = column_data[column_id+"_option"]
      if(data)
      {
        let option = the_column.options.find(item=>item.id == data)
        if(option)
        {
          return option.name
        }
        return null
      }
      return null
    },
    openTemplatesModal()
    {

    },
    onEnter()
    {
      return false
    },
    onCellEditInit(data)
    {
    },
    onCellEditComplete(data)
    {
      let formdata = new FormData()

      let field_id = parseInt(data.field.replace("column_",""))
      let column = this.brand_columns.find(item=>item.id == field_id)
      
      let old_note
      let note
      let field_name
      if(column.columntype=="text")
      {
        field_name = column.id+"_note"
        old_note = data.data[field_name]
        note = data.newData[field_name]
        formdata.append("note",note)
      }

      if(column.columntype=="date")
      {
        field_name = column.id+"_date"
        old_note = data.data[field_name]
        old_note = moment(old_note).format("DD-MM-yyyy")
        if(data.newData[field_name])
        {
          note = data.newData[field_name]
          note = moment(note).format("DD-MM-yyyy")
        }
        
        formdata.append("date",note)
      }

      if(column.columntype=="select")
      {
        field_name = column.id+"_option"
        old_note = data.data[field_name]
        note = data.newData[field_name]
        formdata.append("option",note)
      }
             
      if(note !==old_note)
      {
        let column_id = parseInt(column.id)
        let flowsupplier_id = data.newData.flowsupplier_id
        let supplier_id = data.newData.supplier_id
        
        
        formdata.append("flowsupplier_id",flowsupplier_id)
        formdata.append("supplier_id",supplier_id)
        formdata.append("column_id",column_id)
        formdata.append("item_id",data.newData.id)
        formdata.append("tabletype",this.pagetype)
        this.generalSubmission(formdata,"submit_column_data",this.afterColumnEdit)

        let renew = this.data.findIndex(item=>item.flowsupplier_id == flowsupplier_id)
        if(renew !==-1)
        {
          if(column.columntype=="text")
          {
            this.data[renew][field_name] = note
          }
          if(column.columntype=="date")
          {
            if(note)
            {
              this.data[renew][field_name] = moment(note, "DD-MM-yyyy")
            }
            else
            {
            	this.data[renew][field_name] = null
            }
            
          }
          if(column.columntype=="select")
          {
            this.data[renew][field_name] = note
          }

          
        }
      }
      

    },
    afterColumnEdit(response)
    {     
    },
    openPlannerSpecificColumn()
    {
      this.$refs.planner_dialog.openDialog()
    },
    manageFilterTemplates()
    {
      this.$store.dispatch('ui/setFilterTemplatesSidebar',true)
    },
    async downloadExcel()
    {
      this.preparing_excel = true


      if(this.singleBrandId)
      {
        let brand_columns = await this.generalApiGetWithoutLoader("get_managed_planner_columns/"+this.singleBrandId+"/"+this.pagetype) 

        let renew = this.checkManagedFilters(brand_columns)
        if(renew)
        {
          this.brand_columns =  this.manageBrandColumns(brand_columns)
        }
      }
      else
      {
        this.brand_columns = []
      }

      


      
      let all_filters = this.sanitizeArray(this.filters)

      all_filters = JSON.stringify(all_filters)

      let customattributefilters_sanitized = this.sanitizeArray(this.customattributefilters)
      let customattributefilters = []
      for(let item of customattributefilters_sanitized)
      {
        delete item.fulloptions
        customattributefilters.push(item)
      }
      customattributefilters = JSON.stringify(customattributefilters)
            
     
             
      let data = await this.generalApiGetWithoutLoader("planned_objects/full/"+this.pagetype+"?sort_column="+this.sort_column+"&sort_order="+this.sort_order+"&all_filters="+all_filters+"&searchterm="+this.searchterm+"&customattributefilters="+customattributefilters) 
      
      console.log("data")
      console.log(data)





      this.download_data = await data

      let sheet = []
      let row = await [
      "Tedarikçi İsmi",
      "Tedarikçi Kodu(Markaya Özel)",
      "Marka",
      "Proje",
      "Dönem",
      "Aşama",
      "Aktif Aşama",
      "Durum",
      "Eklenme Tarihi",
      "Oturum Tarihi",
      "Denetçi"
      ]
      for(let column of this.brand_columns)
      {
        row.push(column.name)
      }

      for(let column of this.customattributefilters)
      {
        row.push(column.name)
      }
      await sheet.push(row)


      for(let item of this.download_data)
      {
        let new_row = []
        new_row.push(item.supplier_name)
        new_row.push(item.suppliercode)
        new_row.push(item.brand_name)
        new_row.push(item.project_name)
        new_row.push(item.projectperiod_name)
        new_row.push(item.flow_name)

        if(item.flow_type=="self_evaluation")
        {
          new_row.push(this.$store.state.languages.lang_phrases.self_evaluation)
        }
        else if(item.flow_type=="verification")
        {
          new_row.push(this.$store.state.languages.lang_phrases.verification)
        }
        else if(item.flow_type=="audit")
        {
          new_row.push(this.$store.state.languages.lang_phrases.audit)
        }



        if(item.status=="awaiting_schedule")
        {
          new_row.push(this.$store.state.languages.lang_phrases.planlama_bekliyor)
        }
        else if(item.status=="scheduled")
        {
          new_row.push(this.$store.state.languages.lang_phrases.planlandi)
        }
        else if(item.status=="rescheduled")
        {
          new_row.push(this.$store.state.languages.lang_phrases.tekrar_planlandi)
        }
        else if(item.status=="finished")
        {
          new_row.push(this.$store.state.languages.lang_phrases.tamamlandi0)
        }
        else if(item.status=="under_review")
        {
          new_row.push(this.$store.state.languages.lang_phrases.degerlendirmede)
        }
        else if(item.status=="added_to_verification")
        {
          new_row.push(this.$store.state.languages.lang_phrases.dogrulamaya_aktarildi)
        }
        else if(item.status=="deleted")
        {
          new_row.push(this.$store.state.languages.lang_phrases.iptal_edildi)
        }

        else if(item.status=="canceled")
        {
          new_row.push(this.$store.state.languages.lang_phrases.iptal_edildi)
        }
        else
        {
          new_row.push(item.status)
        }






        new_row.push(moment(item.created_at).format("Do MM YYYY HH:mm"))
        if(item.scheduled_at)
        {
          new_row.push(moment(item.scheduled_at).format("Do MM YYYY HH:mm"))
        }
        else
        {
          new_row.push("")
        }
        if(item.auditor_name)
        {
          new_row.push(item.auditor_name)
        }
        else
        {
          new_row.push("")
        }

        for(let column of this.brand_columns)
        {
        	let column_name
        	if(column.columntype=="text")
        	{
        		column_name = column.id.toString()+"_note"
        		new_row.push(item[column_name])
        	}
        	if(column.columntype=="date")
        	{
        		column_name = column.id.toString()+"_date"
        		let column_data = item[column_name]
        		if(item[column_name])
        		{
        			new_row.push(moment(item[column_name]).format("DD-MM-yyyy"))
        		}
        		else
        		{
        			new_row.push("")
        		}
        		
        	}
        	if(column.columntype=="select")
        	{
        		column_name = column.id.toString()+"_option"
        		if(item[column_name])
        		{
        			let option_ind = column.options.findIndex(option=>option.id == item[column_name])
        			if(option_ind !==-1)
        			{
        				new_row.push(column.options[option_ind].name)
        			}
        			else
        			{
        				new_row.push("")
        			}
        		}
        		else
        		{
        			new_row.push("")
        		}
        		
        		
        	}
           
          
        }

        for(let column of this.customattributefilters)
        {
          let column_name
          if(column.type=="string")
          {
            column_name = column.id.toString()+"_text"
            new_row.push(item[column_name])
          }
          if(column.type=="number")
          {
            column_name = column.id.toString()+"_number"
            new_row.push(item[column_name])
          }
          if(column.type=="select")
          {
            column_name = column.id.toString()+"_select"
            let select_item = item[column_name]
            let selected = column.fulloptions.find(element=>element.id == select_item)
            if(selected)
            {
              new_row.push(selected.name)
            }
            new_row.push("")
            
          }
          if(column.type=="multiselect")
          {
            column_name = column.id.toString()+"_multiselect"
            let select_items = item[column_name]
            if(select_items)
            {
              select_items = JSON.parse(select_items)
              let sentence = ""
              for(let select_item of select_items)
              {
                let selected = column.fulloptions.find(element=>element.id == select_item)
                if(selected)
                {
                  sentence = sentence+selected.name+", "
                }
              }
              sentence = sentence.substring(0, sentence.length-2);
              new_row.push(sentence)

            }
            new_row.push("")

          }
        }

        await sheet.push(new_row)

      }

      let ws = await XLSX.utils.json_to_sheet(sheet)
      let wb = await XLSX.utils.book_new();
      await XLSX.utils.book_append_sheet(wb,ws,"Doğrulamalar")
      await XLSX.writeFile(wb,"Doğrulama raporu.xls")
      

      this.preparing_excel = false
    },
    searchSupplier()
    {
      clearInterval(this.intervalobj);
        this.intervalobj = setInterval(()=>{
            this.page = 0
            this.getData()
            clearInterval(this.intervalobj);
        },1000)

    },
    toggleMenu(event)
    {
      this.$refs.user_menu.toggle(event)
    },
    toggle(event,id) 
    {
        this.$refs['menu'+id].toggle(event);
    },
    onPage(event)
    {
      this.page = event.page
      this.getData()
    },
    
    onFilter(event)
    {
      this.checkTimePeriodState("created_at")
      this.checkTimePeriodState("scheduled_at")
      let date_types = this.brand_columns.filter(item=>item.columntype=="date")
      for(let date_type of date_types)
      {
        this.checkTimePeriodState("column_"+date_type.id)
      }
      this.loading = true
      this.page = 0
      this.selected_projects = []
      this.selected_flows = []
      this.selected_brands = []

      if(event.filters.brand_name.value && event.filters.brand_name.value.length)
      {        
        this.selected_brands = event.filters.brand_name.value
      }
      else
      {        
        this.selected_brands = []
      }

      if(event.filters.project_name.value && event.filters.project_name.value.length)
      {
        
        this.selected_projects = event.filters.project_name.value
      }
      else
      {
        this.selected_projects = []
      }

      if(event.filters.projectperiod_name.value && event.filters.projectperiod_name.value.length)
      {
        
        this.selected_periods = event.filters.projectperiod_name.value
      }
      else
      {
        this.selected_periods = []
      }

      if(event.filters.flow_name.value && event.filters.flow_name.value.length)
      {       
        this.selected_flows = event.filters.flow_name.value
      }
      else
      {
        this.selected_flows = []
      }

      if(event.filters.auditor_name.value && event.filters.auditor_name.value.length)
      {       
        this.selected_auditors = event.filters.auditor_name.value
      }
      else
      {
        this.selected_auditors = []
      }

      if(event.filters.status.value && event.filters.status.value.length)
      {        
        this.selected_statuses = event.filters.status.value
      }
      else
      {
        this.selected_statuses = []
      }
      if(event.filters.flow_type.value && event.filters.flow_type.value.length)
      {        
        this.selected_types = event.filters.flow_type.value
      }
      else
      {
        this.selected_types = []
      }

      this.getBrands() 
    },
    onSort(event)
    {
        this.sort_column = event.sortField  
        if(event.sortOrder===1)
        {
            this.sort_order = "asc"
        }
        else
        {
            this.sort_order = "desc"
        }
        this.getData()      

    },
    async getBrands()
    {
      let roles = this.$store.state.auth.user.userroles.map(item=> item.name)
      if(roles.includes("brand"))
      {
        this.brands = await this.generalApiGetWithoutLoader("brands_for_brandmanager") 
      }
      if(roles.includes("planner"))
      {
        this.brands = await this.generalApiGetWithoutLoader("brands_for_planner") 
      }

      if(roles.includes("admin") || roles.includes("technical_auditor"))
      {
        this.brands = await this.generalApiGetWithoutLoader("brands") 
      }
      
      this.getProjects()
    },
    async getProjects()
    { 
      let selected_brands = []
      if(this.selected_brands.length)
      {
        selected_brands = this.selected_brands
      }
      else
      {
        selected_brands = this.brands.map(item=>item.id)
      }      
      let arr = JSON.stringify(selected_brands)
      this.projects = await this.generalApiGetWithoutLoader("auditable_projects?selected_brands="+arr) 
      await this.getPeriods()
      
    },
    async getPeriods()
    { 
      let selected_projects = []
      if(this.selected_projects.length)
      {
        selected_projects = this.selected_projects
      }
      else
      {
        selected_projects = this.projects.map(item=>item.id)
      }

      let arr = JSON.stringify(selected_projects)
      let periods = await this.generalApiGetWithoutLoader("auditable_periods?selected_projects="+arr)
      this.periods = periods 

      await this.getFlows()
      
    },
    async getFlows()
    {
      let selected_projects = []
      if(this.selected_projects.length)
      {
        selected_projects = this.selected_projects
      }
      else
      {
        selected_projects = this.projects.map(item=>item.id)
      }

      selected_projects = JSON.stringify(selected_projects)
      
      //this.selected_flows = []
      this.flows = await this.generalApiGetWithoutLoader("auditable_flows?flowtype="+this.pagetype+"&selected_projects="+selected_projects)
      this.getAuditors()      
    },
    async getAuditors()
    {
       this.auditors = await this.generalApiGetWithoutLoader("get_auditors")
      this.getData()  
    },
    async applyFilter(filter)
    {
      let filter_obj = JSON.parse(filter.filter)
      console.log(filter_obj)
      let schema = filter_obj.schema


    },
    async prepareFilterData()
    {

    },
  	async getData()
  	{
      
      this.loading = true
      this.totalRecords = 0
      let all_filters = this.sanitizeArray(this.filters)
      if(this.singleBrandId)
      {
        let brand_columns = await this.generalApiGetWithoutLoader("get_managed_planner_columns/"+this.singleBrandId+"/"+this.pagetype) 

        let renew = this.checkManagedFilters(brand_columns)
        if(renew)
        {
          this.brand_columns =  this.manageBrandColumns(brand_columns)
        }
      }
      else
      {
        this.brand_columns = []
        for (const property in all_filters)
        {
          if(property.includes("column"))
          {
            delete all_filters[property]
          }
        }
        this.filters = all_filters
      }
      console.log("brand_columns")
      console.log(this.brand_columns);
      
      console.log("all_filters")
      console.log(all_filters)
      

      if(all_filters.created_at.value && all_filters.created_at.value.length)
      {
        for (let i = 0; i < all_filters.created_at.value.length; i++)
        {          
          if(i===0)
          {            
            all_filters.created_at.value[i] = moment(all_filters.created_at.value[i]).add(3, 'h')
          }
          else
          {            
            all_filters.created_at.value[i] = moment(all_filters.created_at.value[i]).add(27, 'h')
          }
        }
      }
      if(all_filters.scheduled_at.value && all_filters.scheduled_at.value.length)
      {     
        for (let i = 0; i < all_filters.scheduled_at.value.length; i++)
        {
          
          if(i===0)
          {
            all_filters.scheduled_at.value[i] = moment(all_filters.scheduled_at.value[i]).add(3, 'h')
          }
          else
          {
            all_filters.scheduled_at.value[i] = moment(all_filters.scheduled_at.value[i]).add(27, 'h')
          }
          
          
        }
      }
      //adjust date filter timezones
      let date_filters = this.brand_columns.filter(item=>item.columntype=="date")
      for (let i = 0; i < date_filters.length; i++)
      {

        if(all_filters["column_"+date_filters[i].id] && all_filters["column_"+date_filters[i].id].value && all_filters["column_"+date_filters[i].id].value.length)
        {
          let filter_values = all_filters["column_"+date_filters[i].id].value
          for (let ii = 0; ii < filter_values.length; ii++)
          {
            
            if(ii===0)
            {
              filter_values[ii] = moment(all_filters["column_"+date_filters[i].id].value[ii]).add(3, 'h')
            }
            else
            {
              filter_values[ii] = moment(all_filters["column_"+date_filters[i].id].value[ii]).add(27, 'h')
            }
            
          }
        }
      }
      //adjust date filter timezones
      all_filters = JSON.stringify(all_filters)

      let customattributefilters = []
      if(this.singleBrandId)
      {
        let customattributefilters_sanitized = this.sanitizeArray(this.customattributefilters)      
        for(let item of customattributefilters_sanitized)
        {
          delete item.fulloptions
          customattributefilters.push(item)
        }
        
      }
      else
      {
        this.customattributefilters = []
      }  
      customattributefilters = JSON.stringify(customattributefilters) 
             
      let data = await this.generalApiGetWithoutLoader("planned_objects/all/"+this.page+"/"+this.pagetype+"?sort_column="+this.sort_column+"&sort_order="+this.sort_order+"&all_filters="+all_filters+"&searchterm="+this.searchterm+"&customattributefilters="+customattributefilters) 
      console.log(data)
      
      
      this.totalRecords = data.meta.total 
      for(let dataitem of data.data)
      {
        let projectsupplier_uuid = await this.generalApiGetWithoutLoader("planned_objects/projectsupplier_uuid/"+dataitem.project_id+"/"+dataitem.supplier_id+"/"+dataitem.projectperiod_id)
        if(projectsupplier_uuid)
        {
          dataitem.projectsupplier_uuid = projectsupplier_uuid
        } 
      }
      console.log(data)
      
      this.data = await data.data
      this.loading = false 		
  	},
    checkManagedFilters(brand_columns)
    {
      
      let renew = false    
      if(!brand_columns.length) 
      {
        this.clearFilters()
        let renew = true
        return renew
      }
      for (let i = 0; i < brand_columns.length; i++)
      {
        let filter_obj_name = "column_"+brand_columns[i].id
        let managed_ind = this.managed_filters.findIndex(item=>item == filter_obj_name)
        if(managed_ind==-1)
        {
          this.clearFilters()
          renew = true
          break
        }

      }
      return renew
    },
    clearFilters()
    {
      
      for(let filter of this.managed_filters)
      {
        delete this.filters[filter];
      }
      this.managed_filters = []
      
    },
    manageBrandColumns(brand_columns)
    {
      
      for(let column of brand_columns)
      {
        let filter_obj_name = "column_"+column.id
        let managed_ind = this.managed_filters.findIndex(item=>item == filter_obj_name)
        if(managed_ind==-1)
        {
          this.managed_filters.push(filter_obj_name)
        }

        //select type
        if(column.columntype=="select")
        {
          column.options = JSON.parse(column.options)
          column.options.push({name:"Seçimi kaldır",id:null})
          
          let filter_obj = {
            value:null,
            matchMode: FilterMatchMode.IN
          }
          this.filters[filter_obj_name] = filter_obj
        }
        //select type
        //text type
        if(column.columntype=="text")
        {
          let filter_obj = {
            value:null,
            matchMode: FilterMatchMode.CONTAINS
          }
          this.filters[filter_obj_name] = filter_obj

        }
        //text type
        //text date
        if(column.columntype=="date")
        {
          let filter_obj = {
            value:null,
            time_period:null,
            matchMode: FilterMatchMode.IN
          }
          this.filters[filter_obj_name] = filter_obj

        }
        //text date

      }

      return brand_columns
    },
  	
  }
};
</script>

<style lang="css">
.calendar_class{
  transform-origin: center bottom;
}
.loading_overlay
{
    background-color:rgba(53, 47, 141, 0.5);
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    color:#fff;
    flex-direction:column;

}
</style>